import "./table.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const List = (props) => {
  return (
    <TableContainer component={Paper} className="table">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell className="tableCell">Order ID</TableCell>
            <TableCell className="tableCell">Shipment</TableCell>
            <TableCell className="tableCell">Item count</TableCell>
            <TableCell className="tableCell">Created on</TableCell>
            <TableCell className="tableCell">Amount</TableCell>
            <TableCell className="tableCell">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props?.myOrder?.map((row) => (
            <TableRow key={row._id}>
              <TableCell className="tableCell">{row._id}</TableCell>
              <TableCell className="tableCell">
                {row.shippingDetails.fullName}, {row.shippingDetails.city}
              </TableCell>
              <TableCell className="tableCell">
                {row.orderItems.length}
              </TableCell>
              <TableCell className="tableCell">{row.createdAt}</TableCell>
              <TableCell className="tableCell">
                ₦{row.shippingDetails.totalPrice}
              </TableCell>
              <TableCell className="tableCell">
                <div
                  className={`rounded p-2 text-xs text-center ${
                    row.isPaid && row.isDelivered
                      ? "bg-green-500 text-white"
                      : row.isPaid && !row.isDelivered
                      ? "bg-yellow-400 text-gray-800"
                      : "bg-gray-400 text-white"
                  }`}
                >
                  {row.isPaid && row.isDelivered
                    ? "Delivered"
                    : row.isPaid && !row.isDelivered
                    ? "Awaiting delivery"
                    : "Awaiting payment"}
                </div>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default List;
